import { Box, Grid, Paper, Typography, Container, Stack } from '@mui/material';

function addURLStart(url) {
  if (!url) return '#'; // fallback if empty
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  return 'https://' + url; // prepend https if missing
}


const Events = ({ events = [] }) => {
  return (
    <Box
        sx={{
            py: 4,
            display: 'flex',
            justifyContent: 'center',
            
        }}
        >
        <Container
            sx={{
            maxHeight: '40vh',
            overflowY: 'auto',
            px: 2,
            py: 2,
            backgroundColor: '#fff',
            borderRadius: 2,
            boxShadow: 3,
            }}
        >
            <Typography variant="h5" gutterBottom>
                Upcoming Events
            </Typography>
            <Grid container spacing={4} sx={{ mt: 2, justifyContent: 'center'}}>
                <Stack sx={{width: '100%'}}>
                    {events.map((event, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                width: '100%',
                                boxSizing: 'border-box',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                transition: '0.3s',
								'&:hover': { transform: 'translateY(-5px)', boxShadow: 6 },
                            }}
                        >
                            <Box>
                                <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap',}}>
                                    <Typography variant="h6" gutterBottom sx={{paddingRight: 1}}>
                                        {event.Title}
                                    </Typography>
                                    <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                        <Typography variant="body2" color="text.secondary" gutterBottom sx={{paddingRight: 1}}>
                                            {event.Date}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary" gutterBottom>
                                            {event.Location}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Typography variant="body2" gutterBottom>
                                    {event.Description}
                                </Typography>
                            </Box>

                            {event.Link && (
                            <Typography
                                variant="body2"
                                component="a"
                                href={addURLStart(event.Link)}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{ mt: 1, color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                            >
                                {event.LinkText || 'More Info'}
                            </Typography>
                            )}
                        </Paper>
                        </Grid>
                    ))}
                </Stack>
            </Grid>
        </Container>
    </Box>

  );
};

export default Events;
